import { render } from "./CustomCategories.vue?vue&type=template&id=9c7f1916"
import script from "./CustomCategories.vue?vue&type=script&lang=js"
export * from "./CustomCategories.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__